import { BrowserRouter, Route, Routes } from "react-router-dom";
import StartPage from "./Pages/StartPage";
import ProjectsPage from "./Pages/ProjectsPage";

import CertificationsPage from "./Pages/Certifications";
import InformationPage from "./Pages/Information";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route exact path="/" element={<StartPage />} />
        <Route path="/projects" element={<ProjectsPage />} />
        <Route path="/certifications" element={<CertificationsPage />} />
        <Route path="/information" element={<InformationPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
